<template>
    <div>
        <input id="input_image" style="display: none;" type="file"
               accept="image/jpg, image/png, image/jpeg" @change="input_file"
        >
    </div>
</template>

<script>

import {mapMutations, mapActions, mapGetters} from 'vuex';
export default {
  props: {

  },
  computed: {
    ...mapGetters('profile/user', ['user']),
  },
  methods: {
    ...mapMutations('profile/user', [
      'IMAGE_ERROR',
    ]),
    ...mapActions('profile/user', ['post_avatar']),
    ...mapMutations('profile/user', ['SET_USER_AVATAR']),
    input_file(e) {
      let input = e.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          let obj = {
            user  : this.user,
            result: e.target.result,
          };
          if (e.target.result.length > 500000) {
            this.IMAGE_ERROR('Вы не можете загрузить файл больше 500Kб');
          } else {
            this.post_avatar(obj);
          }
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
  },
};
</script>

